import React from "react";

import { Avatar, AvatarProps, useTheme } from "@mui/material";

import { IgBadge } from "./IgBadge";
import { IgCustomTheme } from "./theme";

export interface StatusCircleProps extends Omit<AvatarProps, "children"> {
  color?: "primary" | "secondary" | "error" | "warning" | "info" | "success";
}

export const IgStatusCircle: React.FC<StatusCircleProps> = (props) => {
  const { color = "primary", sx, ...rest } = props;
  const theme = useTheme<IgCustomTheme>();

  const statusColorMap = {
    primary: theme.palette.primary.main,
    secondary: theme.igPrimitives.gray.A200,
    error: theme.igIconColors.error,
    warning: theme.igIconColors.warning,
    info: theme.igIconColors.info,
    success: theme.igIconColors.success,
  };

  return (
    <IgBadge
      variant={"dot"}
      sx={{
        width: 8,
        height: 8,
        backgroundColor: statusColorMap[color],
        borderRadius: 50,
        ...sx,
      }}
    />
  );
};
